/* main-blog.js — placeholder to prevent 404 on /blogs/journal and tag pages.
   Originally referenced from sections/main-blog.liquid. The site's actual blog
   interactivity (load-more, filters) is handled by load-more.js and
   blog-filters.js. This file intentionally no-op to silence 404s in Semrush
   and GSC without removing the script tag (which could break a future
   rollback). */

(function () {
  'use strict';
  // intentionally empty
}());
